import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.4734 3.4157a2.9997 2.9997 0 0 1 4.1433 1.1223l7.0955 12.2423a1 1 0 0 1 .0618.1264 3 3 0 0 1-.2876 2.7934 3 3 0 0 1-2.4724 1.3316l-.007.0001h-14a1 1 0 0 1-.0545-.0015 1 1 0 0 1-.107.0001 2.9995 2.9995 0 0 1-2.8332-2.725 3 3 0 0 1 .2082-1.4 1 1 0 0 1 .0613-.1251L9.3774 4.5381a3 3 0 0 1 1.096-1.1224M4.9518 19.0333a1 1 0 0 1 .0552-.0015h13.996a1.001 1.001 0 0 0 .8212-.4439 1 1 0 0 0 .1163-.8763L12.8818 5.5332l-.0098-.0173a1 1 0 0 0-1.75 0l-.0098.0173-7.059 12.1791a1 1 0 0 0 .8953 1.3208z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 9c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1m0 6c.5523 0 1 .4477 1 1v.01c0 .5523-.4477 1-1 1s-1-.4477-1-1V16c0-.5523.4477-1 1-1",
        clipRule: "evenodd"
    }, "1")
], "AlertTriangle", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
